import fetch from 'unfetch'
import app from '@/app.js'

export function addVariant (variant, quantity) {
  const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
    variant.inventory_quantity
  ) : null // null means they can add as many as they want

  return fetchCart().then(({ items }) => {
    const existing = items.filter(item => item.id === variant.id)[0] || {}
    const numRequested = (existing.quantity || 0) + quantity

    if (numAvailable !== null && numRequested > numAvailable) {
      const err = `There are only ${numAvailable} of that product available, requested ${numRequested}.`
      app.emit('error', err)
      throw new Error(err)
    } else {
      return addItemById(variant.id, quantity)
    }
  })
}

export function updateAddon (id, quantity) {
  return fetchCart().then(({ items }) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === parseInt(id)) {
        return changeAddon(i + 1, quantity) // shopify cart is a 1-based index
      }
    }
  })
}

export function removeAddon (id) {
  return updateAddon(id, 0)
}

function changeAddon (line, quantity) {
  app.emit('cart:updating')

  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ line, quantity })
  }).then(res => res.json()).then(cart => {

    cart = interceptCartJSON(cart);

    app.hydrate({ cart: cart })
    app.emit('cart:updated', { cart: cart })
    return cart
  })
}

/**
 * Warning: this does not check available products first
 */
export function addItemById (id, quantity) {
  app.emit('cart:updating')

  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id, quantity })
  }).then(r => r.json()).then(item => {
    return fetchCart().then(cart => {
      app.hydrate({ cart: cart })
      app.emit('cart:updated')
      app.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
      // app.emit('updated', { item, cart })
      return { item, cart }
    })
  })
}

// Intercept and update cart json as required by Shopify apps
function interceptCartJSON(cart) {

  // Start BOLD Custom Pricing
  // https://support.boldcommerce.com/hc/en-us/articles/360037180252-Using-AJAX-Themes-with-Custom-Pricing
  if(window.BOLD && BOLD.common && BOLD.common.cartDoctor
    && typeof BOLD.common.cartDoctor.fix === 'function') {
    cart = BOLD.common.cartDoctor.fix(cart);
  }
  if(window.BOLD && BOLD.common && BOLD.common.eventEmitter
    && typeof BOLD.common.eventEmitter.emit === 'function') {
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
  }
  // End BOLD Custom Pricing

  return cart;
}

export function fetchCart () {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'include'
  }).then(res => res.json())
  .then(cart => {
    return interceptCartJSON(cart);
  })
}